import EventBus from '../services/EventBus';

const eventBus = new EventBus();

Object.assign(eventBus, {
    emit: eventBus.emit.bind(eventBus),
    subscribe: eventBus.subscribe.bind(eventBus),
    unsubscribe: eventBus.unsubscribe.bind(eventBus),
});

export default function useEvents() {
    return eventBus;
}
